var _mask, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocationViolationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 36,
    viewBox: "0 0 31 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_7519_6883",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4744 28.1391C28.4238 25.3298 31 20.7158 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 20.7158 2.57625 25.3299 6.52568 28.1392L15.5 35.9112L24.4744 28.1391Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4744 28.1391C28.4238 25.3298 31 20.7158 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 20.7158 2.57625 25.3299 6.52568 28.1392L15.5 35.9112L24.4744 28.1391Z",
    fill: "#CC4525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4744 28.1391L23.8948 27.3243L23.8559 27.352L23.8198 27.3832L24.4744 28.1391ZM6.52568 28.1392L7.18034 27.3833L7.14424 27.352L7.10532 27.3243L6.52568 28.1392ZM15.5 35.9112L14.8454 36.6671L15.5 37.2341L16.1547 36.6671L15.5 35.9112ZM30 15.5C30 20.3785 27.5918 24.6945 23.8948 27.3243L25.0541 28.954C29.2558 25.9652 32 21.0531 32 15.5H30ZM15.5 1C23.5081 1 30 7.49187 30 15.5H32C32 6.3873 24.6127 -1 15.5 -1V1ZM1 15.5C1 7.49187 7.49187 1 15.5 1V-1C6.3873 -1 -1 6.3873 -1 15.5H1ZM7.10532 27.3243C3.40829 24.6946 1 20.3785 1 15.5H-1C-1 21.0531 1.74421 25.9653 5.94605 28.9541L7.10532 27.3243ZM5.87103 28.8952L14.8454 36.6671L16.1547 35.1553L7.18034 27.3833L5.87103 28.8952ZM16.1547 36.6671L25.1291 28.8951L23.8198 27.3832L14.8454 35.1553L16.1547 36.6671Z",
    fill: "white",
    mask: "url(#path-1-inside-1_7519_6883)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationViolationMarker);
export default __webpack_public_path__ + "static/media/icon-locationViolationMarker.25eda46e88b737a92c9422f667790b98.svg";
export { ForwardRef as ReactComponent };